import type { IntlShape } from 'react-intl';

import { JSONTransformer } from '@atlaskit/editor-json-transformer/JSONTransformer-2';
import { WikiMarkupTransformer } from '@atlaskit/editor-wikimarkup-transformer';

import type { Validator } from '../../../types/field-validation';
import type { FormFieldValidation } from '../../../types/form/form-fields';
import type { AdfValue } from '../../../types/form/form-fields/field-values';
import { getTextValidationErrors } from '../text';

const wikiTransformer = new WikiMarkupTransformer();
const jsonTransformer = new JSONTransformer();

export const getRichTextValidationErrors = (
	validation: FormFieldValidation,
	fieldLabel: string,
	intl?: IntlShape,
	adf?: AdfValue,
): ReturnType<Validator> => {
	if (adf) {
		const pmNode = jsonTransformer.parse(adf.adf);
		return getTextValidationErrors(validation, fieldLabel, intl, {
			text: wikiTransformer.encode(pmNode),
		});
	}
	return getTextValidationErrors(validation, fieldLabel, intl, undefined);
};
